let $flickitySlider;
let $flickitySliderGallery;

$(document)
  .ready(($) => {
    $flickitySlider = $('.js-slider-flickity');
    $flickitySliderGallery = $('.js-slider-flickity-gallery');

    if ($flickitySlider.length) {
      $flickitySlider.flickity({
        wrapAround: true,
      });
    }

    if ($flickitySliderGallery.length) {
      $flickitySliderGallery.flickity({
        wrapAround: true,
        pageDots: false,
      });
    }
  });
